import { Moment } from "moment";
import { useState, useEffect } from "react";
import { GameBetExecutionInfo } from "./Models";
import { Payload } from "./Payload";

export const useGameBetExecutionInfo = (loggedIn: boolean | undefined, date: Moment) => {
  const [infos, setInfos] = useState<Payload<{ [key: string]: GameBetExecutionInfo }>>({
    status: "init",
  });

  const dateArg = `${date.year()}-${date.month() + 1}-${date.date()}`;

  useEffect(() => {
    function getDetails() {
      fetch(`/api/GameBetExecutionInfo?date=${dateArg}`)
        .then((response) => response.json())
        .then((response) => setInfos({ status: "loaded", payload: response }))
        .catch((error) => {
          console.log(error.toString());
          setInfos({ status: "error", error });
        });
    }
    if (loggedIn === true) {
      getDetails();
      const interval = setInterval(() => getDetails(), 60000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [dateArg, loggedIn]);

  return { infos, setInfos };
};
